import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "BoxLinkList",
    component: () => (__SERVER__ ? require("./box-link-list-view") : import("./box-link-list-view"))
});

export default definition;
